var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSrIconFamilie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4C446E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,148.1c14.7,0,26.7-11.9,26.7-26.7c0-14.7-11.9-26.7-26.7-26.7c-14.7,0-26.7,11.9-26.7,26.7 C179,136.1,190.9,148.1,205.6,148.1z M205.6,104.3c9.5,0,17.1,7.7,17.1,17.1c0,9.5-7.7,17.1-17.1,17.1s-17.1-7.7-17.1-17.1 C188.5,111.9,196.2,104.3,205.6,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.8,157.7c2.2,2.2,4.1,4.5,6,7c4.2-1.9,8.9-3,13.8-3c18.6,0,33.8,15.1,33.8,33.8c0,2-0.2,4-0.5,5.9h9 c0.3-1.9,0.4-3.9,0.4-5.9c0-23.6-19.1-42.7-42.7-42.7C198.5,152.8,191.8,154.6,185.8,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.1,201.4h8.9c0-29.4-23.9-53.3-53.3-53.3s-53.3,23.9-53.3,53.3h8.9c0-24.5,19.9-44.4,44.4-44.4 S186.1,176.9,186.1,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.6,139.2c17.2,0,31.1-13.9,31.1-31.1S158.8,77,141.6,77s-31.1,13.9-31.1,31.1S124.5,139.2,141.6,139.2z  M141.6,85.3c12.6,0,22.8,10.2,22.8,22.8c0,12.6-10.2,22.8-22.8,22.8s-22.8-10.2-22.8-22.8C118.9,95.5,129.1,85.3,141.6,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,201.4c-0.3-1.9-0.5-3.9-0.5-5.9c0-18.6,15.1-33.8,33.8-33.8c4.9,0,9.6,1.1,13.8,3c1.8-2.5,3.8-4.8,6-7 c-5.9-3.1-12.6-4.9-19.8-4.9c-23.6,0-42.7,19.1-42.7,42.7c0,2,0.1,4,0.4,5.9H44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,148.1c14.7,0,26.7-11.9,26.7-26.7c0-14.7-11.9-26.7-26.7-26.7c-14.7,0-26.7,11.9-26.7,26.7 C51,136.1,62.9,148.1,77.7,148.1z M77.7,104.3c9.5,0,17.1,7.7,17.1,17.1c0,9.5-7.7,17.1-17.1,17.1s-17.1-7.7-17.1-17.1 C60.5,111.9,68.2,104.3,77.7,104.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrIconFamilie);
export default __webpack_public_path__ + "static/media/SR_Icon_Familie.c0feb4627cf444376c6c5060782f6ef9.svg";
export { ForwardRef as ReactComponent };